/**
 * useRecaptcha — hook for Google reCAPTCHA Enterprise token generation.
 *
 * The enterprise script is loaded via index.html. This hook waits for
 * grecaptcha.enterprise to be ready and exposes an `execute(action)` function.
 */
import { useCallback } from "react";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export function useRecaptcha() {
  const execute = useCallback(async (action) => {
    if (!SITE_KEY) return ""; // No key configured — skip
    // Wait for grecaptcha.enterprise to load (max 5s)
    for (let i = 0; i < 25; i++) {
      if (window.grecaptcha?.enterprise?.execute) break;
      await new Promise((r) => setTimeout(r, 200));
    }
    if (!window.grecaptcha?.enterprise?.execute) return "";
    try {
      return await new Promise((resolve) => {
        window.grecaptcha.enterprise.ready(async () => {
          const token = await window.grecaptcha.enterprise.execute(SITE_KEY, { action });
          resolve(token);
        });
      });
    } catch (_e) {
      return "";
    }
  }, []);

  return { execute };
}
